import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/auth/AuthContext'
import { isStaff } from '@/auth/access'
import { authService } from '@/services/AuthService'
import { switchableVenueKeys } from '@/hooks/queryKeys'

/**
 * The venues this session can switch into. Comes from `/auth/me/venues` rather
 * than the venues list, which is narrowed to the venue you are already in.
 */
export function useSwitchableVenues() {
  const { user } = useAuth()
  const relevant = isStaff(user)
  return useQuery({
    queryKey: switchableVenueKeys.list(),
    queryFn: () => authService.switchableVenues(),
    enabled: relevant,
    staleTime: 5 * 60 * 1000,
  })
}

/** Set the venue you land in on sign-in. */
export function useSetPrimaryVenue() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (venueId: string) => authService.setPrimaryVenue(venueId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: switchableVenueKeys.all })
    },
  })
}
